<template>
  <RevCard>
    <div class="body-2-bold mb-24 flex items-center">
      <div
        class="border-static-default-low rounded-sm relative flex h-40 w-40 items-center justify-center border"
      >
        <RevIllustration
          :alt="title"
          class="h-32 w-32"
          data-qa="replacement-product-picture"
          data-test="replacement-product-picture"
          :height="32"
          :src="image"
          :width="32"
        />
      </div>
      <span
        class="text-static-default-hi ml-24"
        data-qa="replacement-product-title"
        data-test="replacement-product-title"
        >{{ title }}</span
      >
    </div>
    <RevRadio
      id="express-replacement-delivery-option"
      v-model="modelValue"
      data-qa="delivery-option-radio"
      data-test="delivery-option-radio"
      :value="carrierName"
      variant="full"
    >
      <template #label>
        <span
          class="body-1-bold"
          data-qa="delivery-date"
          data-test="delivery-date"
        >
          {{
            i18n(translations.deliveryOptionLabel, {
              min: i18n.date(new Date(dateMin), DATE_FORMAT),
              max: i18n.date(new Date(dateMax), DATE_FORMAT),
            })
          }}
        </span>
      </template>
      <template #description>
        {{ carrierName }}
      </template>
    </RevRadio>
  </RevCard>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { DateDate } from '@backmarket/http-api'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevCard } from '@ds/components/Card'
import { RevIllustration } from '@ds/components/Illustration'
import { RevRadio } from '@ds/components/Radio'

import { DATE_FORMAT } from '~/scopes/customer-care/resolution/pages/express-replacement/shipping/ExpressReplacementShipping.constants'

import translations from './XrDeliveryOption.translations'

interface XrDeliveryOptionProps {
  title: string
  image: string
  carrierName: string
  dateMin: DateDate
  dateMax: DateDate
}

defineProps<XrDeliveryOptionProps>()

const modelValue = ref(true)

const i18n = useI18n()
</script>
